import React, { useState, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';
import logo from '../img/accion-logo.png';

export default function Menu() {
    return (
        <header className="flex-row align-center space-between">
            <Link to="/"><img src={logo} alt="" /></Link>
            <nav>                
                <NavLink className={({ isActive }) => isActive ? "active" : ""} to="/nosotros">Quiénes Somos</NavLink>
                <NavLink className={({ isActive }) => isActive ? "active" : ""} to="/casos">Casos</NavLink>
                <NavLink className={({ isActive }) => isActive ? "active" : ""} to="/proyectos">Proyectos</NavLink>
                <NavLink className={({ isActive }) => isActive ? "active" : ""} to="/denuncias">Denuncias</NavLink>
                <NavLink className={({ isActive }) => isActive ? "active" : ""} to="/biblioteca">Biblioteca</NavLink>
                <NavLink className={({ isActive }) => isActive ? "active" : ""} to="/noticias">Noticias</NavLink>
                <NavLink className={({ isActive }) => isActive ? "active" : ""} to="/donaciones">Donaciones</NavLink>
            </nav>            
        </header>
    )
}